import {Model} from '@vuex-orm/core';
import {IUsers} from '@/interfaces/commons/IUsers';
import School from './School';
import Privileges from './Privileges';

// @ts-ignore
export default class User extends Model implements IUsers {
    static entity = 'users';

    static fields () {
        return {
            userId: this.number(null),
            fullName: this.string(''),
            userName: this.string(''),
            isUTP: this.boolean(false),
            role: this.string(''),
            roles: this.attr([]),
            privileges: this.belongsTo(Privileges, 'privilegeId'),
            school: this.belongsTo(School, 'schoolId'),
        };
    }
};
